import { CalendarViewPage } from '@/views/calendar/CalendarViewPage';
import { CalendarMapTestPage } from '@/views/calendar/CalendarMapTestPage';

export default [
    {
        path: '/calendar/main',
        alias: '/',
        name: 'CalendarViewPage',
        component: CalendarViewPage,
        meta: {
            hideHeader: true,
        },
    },
    {
        path: '/calendar/map/test',
        alias: '/',
        name: 'CalendarMapTestMonth',
        component: CalendarMapTestPage,
        meta: {
            hideHeader: true,
        },
    },
    {
        path: '/calendar/main/year',
        alias: '/',
        name: 'CalendarViewPageYear',
        component: CalendarViewPage,
        meta: {
            hideHeader: true,
        },
    },
];
